import { Component, Input, ViewChild } from '@angular/core';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ReimbursementformService } from '../Model/Reimbursement/reimbursementform.service';
import { CommonService } from '../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { SessionService } from '../Util/Session/session.service';
import { UtilityService } from '../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { CommonModule, JsonPipe } from '@angular/common';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-admin-reimbursement-history',
  standalone: true,
  imports: [CommonModule, RouterModule, FormsModule, DataTablesModule, NgbDropdownModule, LoaderComponent, NgbDatepickerModule],
  providers: [
      { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
  templateUrl: './admin-reimbursement-history.component.html',
  styleUrl: './admin-reimbursement-history.component.scss'
})
export class AdminReimbursementHistoryComponent {

  @Input() EmployeeId = 0;
  @Input() EmpType = '';

  isDisabled: boolean = false;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  user = [] as any;
  Filter = {
    SelectType: '1',
    EmpMasterId: null as any,
    ApprovalStatus: 'ALL',
    Remark: null,
    ESS_ReimbursementRequestId: null,
    ESS_ReimbursementTypeId: null as any,
    OutstandingAmount: null,
    BillAmount: null,
    ClaimedAmount: null,
    MonthYear: '',
    selectedMonth: null as any,
    selectedYear: '',
    Attachment: '',
    IsWithdraw: false,
    IsCheckedbox: false
  }
  selectedMonth: any = null;
  dtoptions: DataTables.Settings = {};
  constructor(
    private reimbursement: ReimbursementformService,
    protected common: CommonService,
    private toast: ToastService,
    private session: SessionService,
    private utility: UtilityService,
    private dateFromat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.Filter.EmpMasterId = this.user.UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ReimbursementLoad();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Filter.IsWithdraw) {
        this.ESS_ReimbursementWithdrawLoad();
      } else {
        this.ESS_ReimbursementLoad();
      }
    } else {
      form.submitted = true;
    }
  }

  ESS_ReimbursementLoad() {
    this.Filter.EmpMasterId = this.user.UserId;
    this.Filter.SelectType = '1';
    this.Filter.MonthYear = this.Filter.IsCheckedbox ? this.Filter.MonthYear : '';
    this.isDisabled = true
    this.reimbursement.ESS_ReimbursementRequest_Load(this.Filter).subscribe({
      next: (data) => {
        // if (data && data.Table.length > 0) {
        this.TableDatas = data.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false
        // }
        // else {
        //   this.TableDatas = [];
        //   this.isDisabled = false
        // }
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
        this.isDisabled = false
        console.error('Error:', error);
      },
    });
  }

  ESS_ReimbursementWithdrawLoad() {
    this.isDisabled = true;
    this.Filter.MonthYear = this.Filter.IsCheckedbox ? this.Filter.MonthYear : '';
    this.Filter.SelectType = '3'
    this.Filter.EmpMasterId = this.user.UserId;
    this.reimbursement.ESS_ReimbursementRequest_Load(this.Filter).subscribe({
      next: (response) => {
        this.TableDatas = response.Table;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Clear() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  async WithdrawReimbursement(index: any) {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to withdraw?';
    modalRef.result.then(result => {
      if (this.common.PageRight.IsView) {
        if (result) {
          this.isDisabled = true;
          this.reimbursement.ESS_ReimbursementRequest_Insert({ SelectType: 'WITHDRAW', ESS_ReimbursementRequestId: this.TableDatas[index]['ESS_ReimbursementRequestId'] }).subscribe({
            next: (response) => {
              if (response.Error_Code == '590') {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.ESS_ReimbursementLoad();
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    });
  }
  // onNavigate() {
  //   const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
  //   const endDate = new Date(this.selectedMonth.year, this.selectedMonth.month, 0);
  //   this.startFromDate = startFromDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  //   this.startToDate = endDate.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  // }

  onNavigate() {
    const startFromDate = new Date(this.selectedMonth.year, this.selectedMonth.month - 1, 1);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long' };
    this.Filter.MonthYear = startFromDate.toLocaleDateString('en-GB', options);
  }

}